class Middleware {
    constructor() {
        this.id = -1;
        this.middleware = [];
    }
    list() {
        return this.middleware;
    }
    register(fn, options) {
        this.id++;
        let id = this.id;
        this.middleware.push({ id, fn, options });
        return id;
    }
    unregister(id) {
        if (this.middleware?.length === 0) {
            return;
        }
        if (typeof id !== 'number' || id === -1) {
            console.error(`${id} is not valid a valid id`);
            return;
        }
        const index = this.middleware.findIndex(mw => mw.id === id);
        if (index === -1) {
            console.error(`${id} not found in the list of middlewares`);
            return;
        }
        this.middleware.splice(index, 1);
    }
    execute(data, condition) {
        if (this.middleware?.length === 0) {
            return data;
        }
        let nextData = data;
        this.middleware.forEach(mw => {
            if (typeof condition !== 'function') {
                nextData = mw.fn(nextData) ?? nextData;
            }
            else if (condition(mw.options)) {
                nextData = mw.fn(nextData) ?? nextData;
            }
        });
        return nextData;
    }
}
export default Middleware;
